import { Options } from '@/components/Common/Selects/Select.types';
import { create } from 'zustand';

type SeriesStore = {
  selectedSerieValues: Options[] | null;
  setSelectedSerieValues: (series: Options[] | null) => void;
};

export const useSeriesStore = create<SeriesStore>()((set) => ({
  selectedSerieValues: null,
  setSelectedSerieValues: (selectedSerieValues) => set({ selectedSerieValues }),
}));
